// This is just for transition out and in when navigating to a new page

// note to myself: using body>.lay-content on many places so this wont animate columns in overlays

import { Utility, getVisibleMasonryColumns, waitForMasonryInitialized } from '../../utility/utility_controller'
import visibility_gate from '../lifecycle/visibility_gate'
import animation_lifecycle_controller from '../lifecycle/animation_lifecycle_controller'
import { SCOPES } from '../../scope/scope'
import { getEasedStaggerDelayForTransitionIn } from '../shared/geatEasedStaggerDelay'
import { waitForInviewImagesLoaded } from '../shared/waitForImageLoad'
import { sortByVisual } from '../shared/sortByVisual'
import '../shared/setEasings'
import { getColumnsToAnimate } from '../shared/getColumnsToAnimate'
import { normalizeStaggerTargets, getNormalizedStaggerIndex, getNormalizedStaggerLength, clearNormalizedStaggerTargets } from '../shared/normalizeStaggerTargets'

var doTransitionsForPageOverlays = layData.use_revealing_transition_when_opening_page_overlay == 'on' ? true : false
var navTransitionTargetClass = 'lay-nav-transition-in-target'

var visibleRevealDescendantSelector = 'img, video, .ph, .lay-image-responsive, .lay-text, .lay-text-animation, [data-lay-scroll-anim], [data-lay-build-anim-group], .element-wrap'

var getVisibleRootRectForTarget = function (target) {
	var pageOverlay = target && target.closest ? target.closest('.lay-overlay') : null
	if (pageOverlay) {
		return pageOverlay.getBoundingClientRect()
	}
	return {
		top: 0,
		left: 0,
		right: window.innerWidth,
		bottom: window.innerHeight,
		width: window.innerWidth,
		height: window.innerHeight,
	}
}

var isRectInsideRoot = function (rect, rootRect, yOffset) {
	yOffset = yOffset || 0
	return rect.bottom > rootRect.top && rect.top < rootRect.bottom + yOffset && rect.right > rootRect.left && rect.left < rootRect.right
}

var isElementVisibleInOwnRoot = function (el, yOffset) {
	if (!el) {
		return false
	}
	var rect = el.getBoundingClientRect()
	if (rect.width <= 0 || rect.height <= 0) {
		return false
	}
	return isRectInsideRoot(rect, getVisibleRootRectForTarget(el), yOffset)
}

var isNavTransitionTargetVisiblyInViewport = function (col) {
	if (!col) {
		return false
	}
	if (isElementVisibleInOwnRoot(col, 0)) {
		return true
	}
	if (!col.querySelectorAll) {
		return false
	}
	var visibleChildren = col.querySelectorAll(visibleRevealDescendantSelector)
	for (var i = 0; i < visibleChildren.length; i++) {
		var rect = visibleChildren[i].getBoundingClientRect()
		if (rect.width <= 0 || rect.height <= 0) {
			continue
		}
		if (isElementVisibleInOwnRoot(visibleChildren[i], 0)) {
			return true
		}
	}
	var allChildren = col.querySelectorAll('*')
	for (var j = 0; j < allChildren.length; j++) {
		var childRect = allChildren[j].getBoundingClientRect()
		if (childRect.width <= 0 || childRect.height <= 0) {
			continue
		}
		if (isElementVisibleInOwnRoot(allChildren[j], 0)) {
			return true
		}
	}
	return false
}

var finalizeNavTransitionRevealState = function (col) {
	if (!col || !col.classList) {
		return false
	}
	col.style.transitionDelay = ''
	if (col.dataset.layNavTransitionStartedInViewport === '0') {
		if (isNavTransitionTargetVisiblyInViewport(col) || col.classList.contains('no-animation') || col.classList.contains('no-animate-in-on-scroll')) {
			col.classList.remove('below')
			col.classList.remove('in-view')
			delete col.dataset.layRevealLockedUntil
			return false
		}
		col.classList.remove('in-view')
		col.classList.add('below')
		return true
	}
	col.classList.remove('below')
	col.classList.remove('in-view')
	delete col.dataset.layRevealLockedUntil
	return false
}

var revealDeferredNavTransitionTargetIfVisible = function (col) {
	window.requestAnimationFrame(function () {
		if (!col || !col.classList || !col.classList.contains('below')) {
			return
		}
		if (!isNavTransitionTargetVisiblyInViewport(col)) {
			return
		}
		col.style.transitionDelay = ''
		col.classList.remove('below')
		col.classList.add('in-view')
		col.dataset.layRevealLockedUntil = Date.now() + 500
	})
}

var getTranslateYFromTransformString = function (transform) {
	if (!transform || transform === 'none') {
		return 0
	}
	if (transform.indexOf('matrix3d(') === 0) {
		var matrix3dValues = transform.substring(9, transform.length - 1).split(',')
		var matrix3dY = parseFloat(matrix3dValues[13])
		return isNaN(matrix3dY) ? 0 : matrix3dY
	}
	if (transform.indexOf('matrix(') === 0) {
		var matrixValues = transform.substring(7, transform.length - 1).split(',')
		var matrixY = parseFloat(matrixValues[5])
		return isNaN(matrixY) ? 0 : matrixY
	}
	if (transform.indexOf('translate3d(') === 0 || transform.indexOf('translate(') === 0) {
		var start = transform.indexOf('(') + 1
		var end = transform.indexOf(')')
		var values = transform.substring(start, end).split(',')
		var yValue = values.length > 1 ? parseFloat(values[1]) : 0
		return isNaN(yValue) ? 0 : yValue
	}
	return 0
}

var getNavTransitionBaseTranslateY = function (el) {
	if (!el) {
		return 0
	}
	var hasParallaxOrOffsetTransform = !!(
		el._layParallaxTransform ||
		(el.classList && el.classList.contains('has-parallax')) ||
		el.hasAttribute('data-yvel') ||
		el.hasAttribute('data-offsetx') ||
		el.hasAttribute('data-offsety')
	)
	if (!hasParallaxOrOffsetTransform) {
		return 0
	}
	var transform = el._layParallaxTransform || (el.style ? el.style.transform : '')
	if (!transform || transform === 'none') {
		try {
			transform = window.getComputedStyle(el).transform
		} catch (e) {}
	}
	return getTranslateYFromTransformString(transform)
}

var pageoverlays_animations_controller = {
	i: function () {
		if (doTransitionsForPageOverlays) {
			bindPageOverlayBeforeShown()
			bindPageOverlayShown()
			bindTransitionEvents()
		}
	},
}

var bindPageOverlayBeforeShown = function () {
	if (doTransitionsForPageOverlays) {
		window.laytheme.on('page_overlay_before_shown', function () {
			visibility_gate.hideScope(SCOPES.PAGE_OVERLAY)
		})
	}
}

// we dont need transition out for page overlays

var bindTransitionEvents = function () {
	window.laytheme.on('pageoverlay_transition_in', function (type) {
		// wait because transition_in might get called directly after hide stylesheet is inserted into dom
		setTimeout(function () {
			var $parents = jQuery(column_selectors.join(','))
			var masonryCols = getVisibleMasonryColumns($parents)
			if (masonryCols.length > 0) {
				// hide masonry elements that are about to be animated!
				// hideMasonryInnerElementsBeforeReveal(masonryCols);
				jQuery
					.when(waitForMasonryInitialized(masonryCols))
					.then(function () {
						// whether elements inside a masonry layout are inside the viewport
						// and whether they are positioned correctly, depends on if masonry has completed placing all elements

						// we do a set timeout 0, because in history_controller, function "scrollToLastPosition"
						// we also bind to jQuery.when(waitForMasonryInitialized
						// until we scroll to the last position, and the scroll position is important
						// for stagger animation
						setTimeout(function () {
							doTransitionIn(type)
						}, 50)
					})
					.catch(function (err) {})
			} else {
				doTransitionIn(type)
			}
		}, 0)
	})
}

var doTransitionIn = function (type) {
	// when transition is 'none', even though i use anime and timeline, the events "begin" and "complete"
	// dont get triggered, which i think is a animejs bug

	var translateVal = Utility.isPhoneSize ? parseInt(layData.navigation_transition_y_translate_phone, 10) : parseInt(layData.navigation_transition_y_translate_desktop, 10)

	// only animate elements in viewport

	var $columns = jQuery(column_selectors.join(','))
	var colsInViewport = getColumnsToAnimate($columns, layData.navigation_transition_in, 'transition_in')
	colsInViewport = colsInViewport.filter(function (col) {
		return isNavTransitionTargetVisiblyInViewport(col)
	})
	for (var i = 0; i < colsInViewport.length; i++) {
		if (colsInViewport[i].querySelector && colsInViewport[i].querySelector('[data-lay-build-anim-group]')) {
			colsInViewport[i]._laySyncMute = true
		}
	}
	var colsForTransitionInAnimation = Array.isArray(colsInViewport)
		? colsInViewport.filter(function (col) {
			return !col._laySyncMute
		})
		: colsInViewport

	// just end it here, if there is nothing to animate
	if (colsInViewport.length == 0) {
		//make sure to remove hiding stylesheets
		visibility_gate.showScope(SCOPES.PAGE_OVERLAY)
		onTransitionInComplete([])
		return
	}
	// sort columms by position left
	// need this because stagger animation depends on this order and dom order can be different than visual order
	if (layData.navigation_transition_in.indexOf('stagger') != -1 && colsInViewport.length > 1) {
		sortByVisual(colsInViewport, layData.navigation_transition_in)
		normalizeStaggerTargets(colsInViewport)
	}

	// when animation is none, we dont need to disable lazyload transitions
	// because we reveal the page without waiting for in view images to have loaded
	if (layData.navigation_transition_in != 'none') {
		// only need this for reveal!
		for (var i = 0; i < colsInViewport.length; i++) {
			var col = colsInViewport[i]
			col.dataset.layNavTransitionStartedInViewport = isNavTransitionTargetVisiblyInViewport(col) ? '1' : '0'
			col.classList.add('disable-css-transitions')
			col.classList.add(navTransitionTargetClass)

			// Store the original inline opacity if it exists, otherwise default to 1
			if (col.style.opacity && col.style.opacity !== '') {
				col._layTargetOpacity = parseFloat(col.style.opacity)
			} else {
				col._layTargetOpacity = 1
			}
			col._layNavTransitionBaseTranslateY = getNavTransitionBaseTranslateY(col)
		}
	}

	var myTimeline = anime.timeline({
		autoplay: false,
		begin: function () {
			// Pre-apply opacity:0 inline BEFORE removing the page-overlay hide-css
			// — anime.js's from-state lands on the FIRST rAF tick after play(),
			// not in this begin callback. Without this bridging step, between
			// `showScope` and the first tick the browser can paint cols at
			// their natural (visible) state → the "content shown → exits → fades
			// in" flash users saw on first-visit-revealing + page-overlay-
			// revealing combo. Same fix pattern as navigation_animations_controller's
			// timeline begin (see comment there for the full bug trace).
			// Skip for 'none' / 'fade' (the tween animates the wrap, not the cols).
			if (!onlyAnimateWrap && Array.isArray(colsForTransitionInAnimation)) {
				for (var i = 0; i < colsForTransitionInAnimation.length; i++) {
					colsForTransitionInAnimation[i].style.opacity = '0'
					colsForTransitionInAnimation[i].classList.remove('below')
				}
			}
			if (doTransitionsForPageOverlays) {
				visibility_gate.showScope(SCOPES.PAGE_OVERLAY)
			}
		},
		complete: function () {
			onTransitionInComplete(colsInViewport)
		},
	})
	var onlyAnimateWrap = layData.navigation_transition_in == 'none' || layData.navigation_transition_in == 'fade' ? true : false
	var targets = '.lay-show-overlay #grid, .lay-show-overlay #custom-phone-grid'
	// only animating one dom element is just more performant!
	// we could also do up and down by just animating wrap, however, this creates a bug with a background image in chrome
	// and it also moves the wrap's background image which looks weird maybe

	if (onlyAnimateWrap) {
		switch (layData.navigation_transition_in) {
			case 'none':
				myTimeline.add({
					targets: targets,
					opacity: 1,
					easing: layData.navigation_transition_in_easing,
					duration: 0,
				})
				break
			case 'fade':
				myTimeline.add({
					targets: targets,
					opacity: [0, 1],
					easing: layData.navigation_transition_in_easing,
					duration: layData.navigation_transition_in_duration,
				})
				break
		}
	} else if (colsInViewport != undefined && Array.isArray(colsInViewport) && colsInViewport.length > 0) {
			// first animate in wrap
			myTimeline.add({
				targets: targets,
				opacity: 1,
				easing: 'easeOutSine',
				duration: 0,
			})

			var doColAnimations = true
			if (!Array.isArray(colsForTransitionInAnimation) || colsForTransitionInAnimation.length === 0) {
				doColAnimations = false
			}

			// then animate in regular columns. Columns that contain Build Animation
			// Group / Sync-with-Nav elements are kept out of this timeline entirely;
			// their inner element animations own the visual reveal.
			var translateUpValueFn = function (el) {
				var baseY = isFinite(el._layNavTransitionBaseTranslateY) ? el._layNavTransitionBaseTranslateY : getNavTransitionBaseTranslateY(el)
				el._layNavTransitionBaseTranslateY = baseY
				return [translateVal, 0]
			}
			var translateDownValueFn = function (el) {
				var baseY = isFinite(el._layNavTransitionBaseTranslateY) ? el._layNavTransitionBaseTranslateY : getNavTransitionBaseTranslateY(el)
				el._layNavTransitionBaseTranslateY = baseY
				return [-translateVal, 0]
			}
			var opacityInValueFn = function (el) {
				return [0, el._layTargetOpacity !== undefined ? el._layTargetOpacity : 1]
			}
			if (doColAnimations) {
				switch (layData.navigation_transition_in) {
					case 'stagger-fade':
						myTimeline.add({
							targets: colsForTransitionInAnimation,
							opacity: opacityInValueFn,
							easing: layData.navigation_transition_in_easing,
							duration: layData.navigation_transition_in_duration,
							delay: function (el, index, length) {
								return getEasedStaggerDelayForTransitionIn(getNormalizedStaggerIndex(el, index), getNormalizedStaggerLength(el, length))
							},
						})
						break
					case 'stagger-up':
						myTimeline.add({
							targets: colsForTransitionInAnimation,
							translateY: translateUpValueFn,
							opacity: opacityInValueFn,
							easing: layData.navigation_transition_in_easing,
							duration: layData.navigation_transition_in_duration,
							delay: function (el, index, length) {
								return getEasedStaggerDelayForTransitionIn(getNormalizedStaggerIndex(el, index), getNormalizedStaggerLength(el, length))
							},
						})
						break
					case 'stagger-down':
						myTimeline.add({
							targets: colsForTransitionInAnimation,
							translateY: translateDownValueFn,
							opacity: opacityInValueFn,
							easing: layData.navigation_transition_in_easing,
							duration: layData.navigation_transition_in_duration,
							delay: function (el, index, length) {
								return getEasedStaggerDelayForTransitionIn(getNormalizedStaggerIndex(el, index), getNormalizedStaggerLength(el, length))
							},
						})
						break
					case 'up':
						myTimeline.add({
							targets: colsForTransitionInAnimation,
							translateY: translateUpValueFn,
							opacity: opacityInValueFn,
							easing: layData.navigation_transition_in_easing,
							duration: layData.navigation_transition_in_duration,
						})
						break
					case 'down':
						myTimeline.add({
							targets: colsForTransitionInAnimation,
							translateY: translateDownValueFn,
							opacity: opacityInValueFn,
							easing: layData.navigation_transition_in_easing,
							duration: layData.navigation_transition_in_duration,
						})
						break
				}
			}
		}

	if (layData.navigation_transition_in == 'none') {
		myTimeline.play()
		// when layData.navigation_transition_in is 'none', myTimeline.complete and begin do trigger
		// so i just call this function here:

		onTransitionInComplete(colsInViewport, type)
	} else {
		var $columns = jQuery(column_selectors.join(','))
		// note to myself: it seems like when using a scroll to hash
		// like: http://localhost:10020/fs-2/#last
		// with fullscreen slider active, this callback is never evoked, so i just look for a # hash and do play
		if (window.location.href.indexOf('#') != -1) {
			myTimeline.play()
		} else {
			if ((layData.loadingBlur == 'on' && layData.lazyLoading == 'on') || layData.loadingBlur == 'blur') {
				// loadingBlur=on+lazyLoading=on → tiny placeholders, load instantly.
				// loadingBlur=blur → blurred placeholder is already visible, so we
				// can start the stagger immediately and let the full image fade in
				// on top when it loads. Waiting would keep the UI cascade
				// (site title / menu / close icon) sitting idle until images decode.
				myTimeline.play()
			} else {
				waitForInviewImagesLoaded($columns, function () {
					myTimeline.play()
				})
			}
		}
	}

	// Safety net: if `waitForInviewImagesLoaded` never resolves (image 404,
	// network hang) the timeline's `begin` callback won't fire, the hide-css
	// stays, and the page overlay stays invisible forever. A delayed reveal
	// kicks in as fallback.
	//
	// This used to be a SYNCHRONOUS `showScope` here — which on the async-
	// images path removed the hide-css BEFORE anime.js applied the from-
	// state, producing the "flash → invisible → fade-in" sequence users saw
	// on first overlay open. The same pattern + fix lives in
	// navigation_animations_controller.js's `doTransitionIn` (see the long
	// comment there for the full bug trace).
	if (doTransitionsForPageOverlays) {
		visibility_gate.scheduleSafetyReveal(3000)
	}
}

var onTransitionInComplete = function (colsInViewport) {
	jQuery('body').removeClass('do-page-overlay-content-transition')
	window.laytheme.emit('pageoverlay_transition_in_completed')

	// remove style that was applied to .lay-content
	// this removes probably transform: translateY() and opacity, maybe this fixes a background image issue
	let target = '.lay-overlay .lay-content'
	jQuery(target).attr('style', '')
	var delayedCleanupKey = 'page-overlay-transition-targets'
	var delayedCleanupId = animation_lifecycle_controller.beginDelayedCleanup(delayedCleanupKey)
	// remove this class, maybe it could interfere with sth else, not sure. but it has done its work
	// yes it would! interefere with thumbnailgrid filter animation
	for (var i = 0; i < colsInViewport.length; i++) {
		var col = colsInViewport[i]
		var shouldRevealAfterTransitionsAreEnabled = finalizeNavTransitionRevealState(col)
		col.classList.remove('disable-css-transitions')
		if (shouldRevealAfterTransitionsAreEnabled) {
			revealDeferredNavTransitionTargetIfVisible(col)
		}
		setTimeout(function (target, cleanupId, cleanupKey) {
			if (!animation_lifecycle_controller.isDelayedCleanupCurrent(cleanupId, cleanupKey)) {
				return
			}
			target.classList.remove(navTransitionTargetClass)
			delete target.dataset.layNavTransitionStartedInViewport
		}, 3000, col, delayedCleanupId, delayedCleanupKey)
		// Clean up the temporary property
		delete col._layTargetOpacity
		delete col._layNavTransitionBaseTranslateY
	}
	clearNormalizedStaggerTargets(colsInViewport)
	// also remove all styles that were applied by animations, so for example we can filter a thumbnailgrid
	// without new applied styles interfering
	// we only need this the revealing animation
	for (var i = 0; i < colsInViewport.length; i++) {
		var col = colsInViewport[i]
		// actually, only remove opacity styles from elements inside a elementgrid and thumbnailgrid
		// cause we animate the divs inside the thumbnailgrid and elementgrid
		// if we would remove opacity styles of all .cols, this would remove opacities we set with the new sidebar
		if (col.closest('.type-elementgrid') || col.closest('.type-thumbnailgrid')) {
			col.style.opacity = ''
		}
		if (!col.classList.contains('has-parallax') && !col.hasAttribute('data-offsetx') && !col.hasAttribute('data-offsety')) {
			col.style.transform = ''
		}
		// we cant just remove the whole style attribute because that would destroy the masonry layout
	}
}

var bindPageOverlayShown = function () {
	if (doTransitionsForPageOverlays) {
		window.laytheme.on('overlayshown_animation_ended', function ($overlay) {
			var parentSelector =
				'.' +
				$overlay
					.attr('class')
					.split(' ')
					.find((cls) => cls.startsWith('overlay-id-'))

			column_selectors = undefined
			var typeOfContentThatIsReady = Utility.screenSize == 'desktop' || Utility.screenSize == 'tablet' ? 'desktop' : 'phone'
			switch (typeOfContentThatIsReady) {
				case 'desktop':
					column_selectors = [parentSelector + ' #grid', parentSelector + ' #footer']
					break
				case 'phone':
					var footerHasPhoneCPL = jQuery(parentSelector + ' #footer-custom-phone-grid').length != 0
					var hasCPL = jQuery(parentSelector + ' #custom-phone-grid').length != 0

					if (footerHasPhoneCPL && hasCPL) {
						column_selectors = [parentSelector + ' #custom-phone-grid', parentSelector + ' #footer-custom-phone-grid']
					} else if (!footerHasPhoneCPL && hasCPL) {
						column_selectors = [parentSelector + ' #custom-phone-grid', parentSelector + ' #footer']
					} else if (footerHasPhoneCPL && !hasCPL) {
						column_selectors = [parentSelector + ' #grid', parentSelector + ' #footer-custom-phone-grid']
					} else if (!footerHasPhoneCPL && !hasCPL) {
						column_selectors = [parentSelector + ' #grid', parentSelector + ' #footer']
					}
					break
			}

			if (Array.isArray(column_selectors) && column_selectors != undefined) {
				// only animate not-collapsed rows, or placefreely elements ( they are not in rows at all :) )
				for (let index = 0; index < column_selectors.length; index++) {
					column_selectors[index] = column_selectors[index] + ' .row[data-collapsed="false"] .col:not(.type-stack), ' + column_selectors[index] + ' .col.place-freely'
				}
			}

			window.laytheme.emit('pageoverlay_transition_in', 'page_overlay')
		})
	}
}

export default pageoverlays_animations_controller
